import { AfterContentInit, AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { CountryGateway } from 'src/app/application/gateway/CountryGateway';
import { ProfileGateway } from 'src/app/application/gateway/ProfileGateway';
import { Country } from 'src/app/domain/models/Country';
import { ProfileCreateRequest } from 'src/app/domain/models/Profile';
import { Routes } from 'src/app/infrastructure/routes';
import { createPasswordStrengthValidator } from 'src/app/ui/util/custom-validators';
import { ErrorMessageUtil } from 'src/app/ui/util/error-message-util';
import { ProfileUtils } from 'src/app/ui/util/profile-utils';
import { formLimit } from 'src/app/ui/util/form-limit';

@Component({
  selector: 'app-admin-create-user',
  templateUrl: './admin-create-user.component.html',
  styleUrls: ['./admin-create-user.component.css'],

})
export class AdminCreateUserComponent implements OnInit, OnChanges {

  @Output() closeDialog = new EventEmitter();

  profileTypeOptions: any[] = ProfileUtils.getProfileTypeOptions()
  countries: Country[] = []

  loading: boolean = false
  submit: boolean = false
  @Input()
  mockImporter: boolean = false
  @Input()
  exporterRelation: number | undefined = undefined
  @ViewChild('companyName') input!: ElementRef;

  formLimit = formLimit;

  formGroup: FormGroup = this._formBuilder.group({
    profileType: ['', Validators.required],
    contactName: ['', [Validators.required, Validators.maxLength(60)]],
    contactLastName: [null, [Validators.required, Validators.maxLength(60)]],
    contactCountryId: [null, Validators.required],
    contactCity: [''],
    contactAddress: ['', Validators.maxLength(formLimit.addressLimit)],
    contactPhone: [''],
    contactEmail: ['', [Validators.required, Validators.email, Validators.maxLength(formLimit.mailLimit)]],
    vat: ['', Validators.maxLength(formLimit.vatLimit)],
    companyName: ['', Validators.maxLength(formLimit.companyName)],
    sagCode: [null],
    legalRepresentativeName: [''],
    legalRepresentativeNumber: [null, Validators.maxLength(formLimit.legalRepresentativeNumber)],
    hasTwoAuthetication: [false],
    isVerified: [false],
    isSendEmail: [true],
    password: [null, [createPasswordStrengthValidator(), Validators.minLength(8)]]
  })

  constructor(private _router: Router,
    private _formBuilder: FormBuilder,
    private _messageService: MessageService,
    private _countryService: CountryGateway,
    private _profileService: ProfileGateway,
      public translate: TranslateService
  ) {

  }

  ngOnInit(): void {
    this.loadCountries()
  }


  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
      if(changes['mockImporter'] && changes['exporterRelation'])
      {
        this.formGroup.controls['profileType'].setValue(2);
      }
  }


  loadCountries(): void {
    this._countryService.getAll().subscribe({
      next: (v) => {
        this.countries = v
      },
      error: (e) => {
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudo recuperar la lista de países.' });
      }
    })
  }

  save() {
    this.submit = true
    if(this.formGroup.valid) {
      const profile: ProfileCreateRequest = {
        name: this.formGroup.controls['contactName'].value,
        lastName: this.formGroup.controls['contactLastName'].value,
        email: this.formGroup.controls['contactEmail'].value,
        companyName: this.formGroup.controls['companyName'].value,
        contactCountryId: this.formGroup.controls['contactCountryId'].value,
        type: this.formGroup.controls['profileType'].value,
        contactAddress: this.formGroup.controls['contactAddress'].value,
        contactCity: this.formGroup.controls['contactCity'].value,
        isSendEmail: this.formGroup.controls['isSendEmail'].value,
        contactPhone: this.formGroup.controls['contactPhone'].value,
        legalRepresentativeName: this.formGroup.controls['legalRepresentativeName'].value,
        legalRepresentativeNumber: this.formGroup.controls['legalRepresentativeNumber'].value ? this.formGroup.controls['legalRepresentativeNumber'].value.toString() : '',
        vat: this.formGroup.controls['vat'].value,
        sagCode: this.formGroup.controls['sagCode'].value ? this.formGroup.controls['sagCode'].value.toString() : '',
        password: this.formGroup.controls['password'].value
      }

      this.loading = true
      this._profileService.create(profile).subscribe({
        next: (v) => {
          this.loading = false
          this.submit = false
          this.cancel(true)
        },
        error: (e) => {
          this.loading = false
          this.submit = false
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudo crear el usuario. ' + e.error.messageEs });
        }
      })
    }else{
      this.findInvalidControls()
      this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'Hay errores en el formulario. Por favor, validar.' });
    }
  }

  cancel(isReload?: boolean): void {
    this.closeDialog.emit(isReload)
  }

  getErrorMessage(fieldName: string): string {
    return ErrorMessageUtil.getErrorMessage(this.formGroup, this.translate, fieldName);
  }

  goToUsers() {
    this._router.navigate(['/' + Routes.adminUsers])
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.formGroup.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
  }

  public CreateMock()
  {
     this.formGroup.controls['profileType'].setValue(2);
     var baseName = this.formGroup.controls['companyName'].value
     if(!baseName)
     {
       this._messageService.add({
        severity: 'error',
        summary: 'Acción fallida',
        detail: 'Por favor, ingrese un nombre base para el mock en el campo "Nombre de la empresa".' });
     }
      else
      {
        this.assignMockProfile(baseName);
      }
  }

  /**
   * Crea un ProfileCreateRequest mock basado en un string y lo asigna al formulario
   * @param baseName String base para generar el email y otros datos del mock
   */
  public assignMockProfile(baseName: string): void {
    const mockEmail = `${baseName.toLowerCase().replace(/\s+/g, '.')}@example.com`;

    this.formGroup.patchValue({
      profileType: 2, // Tipo de perfil por defecto
      contactName: `${baseName} User`,
      contactLastName: 'Mock LastName',
      contactCountryId: this.countries.length > 0 ? this.countries[0].id : null,
      contactCity: 'Mock City',
      contactAddress: 'Mock Address 123',
      contactPhone: '+1234567890',
      contactEmail: mockEmail,
      vat: 'MOCK123456',
      companyName: `${baseName}`,
      sagCode: '111111',
      legalRepresentativeName: 'Mock Representative',
      legalRepresentativeNumber: '111111111',
      hasTwoAuthetication: false,
      isVerified: true,
      isSendEmail: false,
    });
  }
}
